import * as React from 'react';
import Flex from '../Flex/Flex';
import Icon from '../Icon/Icon';
import Link, { Props as LinkProps } from '../Link/Link';

export interface Props extends LinkProps {}

const ExternalLink: React.FunctionComponent<Props> = (props: Props) => {
  const { children, ...rest } = props;

  return (
    <Link { ...rest }>
      <Flex
          alignChildrenVertical="middle"
          direction="horizontal"
          gap="x1">
        <Flex>
          { children }
        </Flex>

        <Flex>
          <Icon name="OpenInBrowser" />
        </Flex>
      </Flex>
    </Link>
  );
};

export default ExternalLink;
